// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/Panel.css
// module id = 717
// module chunks = 0